import React from "react";
import { useNavigate } from "react-router-dom";


function AddTransaccionVerificarComponents({ cedula, handleCedula, handleVerificarUsuario }) {

    let history = useNavigate();






    return (
        <div className="rounded-xl bg-white p-6 shadow-xl">
            <div className="flex items-center justify-between">
                <h2 className="text-xl font-semibold text-gray-800">Crear transacción</h2>
            </div>

            <div className="mt-5 grid grid-cols-1 gap-5">
                <div>
                    <label className="mb-1.5 block text-sm font-semibold text-gray-700">Cédula de identidad</label>
                    <input
                        value={cedula}
                        onChange={(e) => handleCedula(e.target.value)}
                        onKeyDown={(e) => {
                            if (e.key === 'Enter') {
                                handleVerificarUsuario();
                            }
                        }}
                        type="number"
                        autoCapitalize="none"
                        autoCorrect="off"
                        placeholder="Ingresar cédula"
                        className="w-full rounded-lg border border-gray-200 bg-[#f1f5f9] px-3 py-2.5 text-sm text-gray-700 outline-none transition focus:border-blue-200 focus:ring-2 focus:ring-blue-200"
                    />
                </div>

                <div className="mt-2 flex flex-wrap items-center gap-4 border-t border-gray-200 pt-5">
                    <button
                        type="button"
                        onClick={handleVerificarUsuario}
                        className="rounded-lg bg-[#104063] px-6 py-2 font-medium text-white transition-colors hover:bg-[#0d3553]"
                    >
                        Crear
                    </button>

                    <button
                        type="button"
                        onClick={() => history(-1)}
                        className="rounded-lg bg-gray-100 px-6 py-2 font-medium text-gray-700 transition-colors hover:bg-gray-200"
                    >
                        Cancelar
                    </button>
                </div>
            </div>
        </div>
    );
}

export default AddTransaccionVerificarComponents;